import formatCount from '@UI/Pages/Home/Helpers/formatCount';
import type IndicatorComparisonView from '@UI/Store/Indicators/Views/IndicatorComparisonView';

const MINUS = '−';
const NO_BREAK_SPACE = '\u00A0';

export type NewBeneficiariesText = {
	/** One line: "+3 nouveaux sur la période (▲ +1)". */
	readonly visible: string;
	/** Full sentence fragment for assistive technology, comparison included. */
	readonly spoken: string;
};

/** Texts of the "new dossiers" line; the trend is attached to the figure on one line, not a second one. */
const buildNewBeneficiariesText = (created: IndicatorComparisonView, days: number): NewBeneficiariesText => {
	const count = formatCount(created.current);
	const noun = created.current > 1 ? 'nouveaux' : 'nouveau';
	const reference = `par rapport aux ${days} jours précédents`;
	const base = `+${count} ${noun} sur la période`;
	const spokenBase = `dont ${count} ${noun} sur la période`;
	const difference = formatCount(Math.abs(created.difference));

	switch (created.direction) {
		case 'up':
			return {
				visible: `${base}${NO_BREAK_SPACE}(▲${NO_BREAK_SPACE}+${difference})`,
				spoken: `${spokenBase}, ${difference} de plus ${reference}`,
			};
		case 'down':
			return {
				visible: `${base}${NO_BREAK_SPACE}(▼${NO_BREAK_SPACE}${MINUS}${difference})`,
				spoken: `${spokenBase}, ${difference} de moins ${reference}`,
			};
		case 'stable':
			return { visible: `${base} (= stable)`, spoken: `${spokenBase}, autant ${reference}` };
		case 'new':
			return { visible: `${base} (nouveau)`, spoken: `${spokenBase}, aucun ${reference}` };
		default:
			return { visible: base, spoken: spokenBase };
	}
};

export default buildNewBeneficiariesText;
